// # Posts section component for profile
import React from 'react';
import './prfl_posts.css';

const ProfilePosts = ({ isDarkMode }) => {
  return (
    <div className={`prfl_posts_container ${isDarkMode ? 'prfl_dark-mode' : ''}`}>
      <div className="prfl_posts_coming-soon">
        <h3>Posts Feature Coming Soon</h3>
        <p>Share your medical journey, insights, and experiences with the community.</p>
      </div>
    </div>
  );
};

export default ProfilePosts;
